var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { BaseButton } from "../base-button/BaseButton";
import { IdButtonType } from "../base-button/IdButtonType";
export var ButtonQuestPanelTimeChallenge = React.memo(function (props) { return (React.createElement(BaseButton, __assign({ name: IdStyles.ButtonSpecial, styleId: IdButtonType.ButtonRectangleMedium }, props))); });



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/ButtonQuestPanelTimeChallenge.tsx
// module id = 2280
// module chunks = 3